import { render } from "./vehiclequotationprices.vue?vue&type=template&id=2c1bc95e"
import script from "./vehiclequotationprices.vue?vue&type=script&lang=js"
export * from "./vehiclequotationprices.vue?vue&type=script&lang=js"

import "./vehiclequotationprices.vue?vue&type=style&index=0&id=2c1bc95e&lang=scss"

import exportComponent from "D:\\myWork\\SAAS\\Group-Carwins-H5-1.0\\carwins-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__